import { render, staticRenderFns } from "./GetEmail.vue?vue&type=template&id=2d95424f&scoped=true&"
import script from "./GetEmail.vue?vue&type=script&lang=js&"
export * from "./GetEmail.vue?vue&type=script&lang=js&"
import style0 from "./GetEmail.vue?vue&type=style&index=0&id=2d95424f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95424f",
  null
  
)

export default component.exports